<template>
    <model-modal
        component="v-spa-mixed-modal"
        :model-class="modelClass"
        modal-type="form"
        @opening="onOpening"
        @resetted="onReset"
        ref="modal"
    >
        <template v-slot:default="slotProps">
            <h2 class="mb-4 text-xl">
                {{ model ? $t('opportunity_meetings.edit_modal.title') : $t('opportunity_meetings.create_modal.title') }}
            </h2>
            
            <form @submit.prevent="submit">
                <div class="mb-6">
                    <v-spa-input
                        :label="$t('opportunity_meeting.form.labels.title')"
                        id="opportunity-meeting-form-title"
                        :form="form"
                        input-name="title"
                    ></v-spa-input>
                    <v-spa-textarea
                        :label="$t('opportunity_meeting.form.labels.text')"
                        id="opportunity-meeting-form-text"
                        :form="form"
                        input-name="text"
                    ></v-spa-textarea>
                    <v-spa-address-input :label="$t('opportunity_meeting.form.labels.address')" id="opportunity-meeting-form-address" :form="form" input-name="address"></v-spa-address-input>
                    <v-spa-multiselect :label="$t('opportunity_meeting.form.labels.users')" id="opportunity-meeting-form-users_id" :form="form" input-name="users_id" :options="$store.state.models.users" option-label="name" track-by="id"></v-spa-multiselect>
                    <v-spa-date-picker :popover="{ visibility: 'click' }" :label="$t('opportunity_meeting.form.labels.date')" id="opportunity-meeting-form-date" :form="form" input-name="date"></v-spa-date-picker>
                </div>
                
                <div class="flex justify-end max-w-input">
                    <v-spa-loading-button :loading="form.isLoading()">            
                        {{ model ? $t('opportunity_meetings.edit_modal.button') : $t('opportunity_meetings.create_modal.button') }}
                    </v-spa-loading-button>
                </div>
            </form>
        </template>
    </model-modal>
</template>

<script>
    import ModelModal from '@spa/apps/trustup-pro-base-js/components/Model/Modal';
    import OpportunityMeeting from '@spa/apps/trustup-pro-worksite-js/models/OpportunityMeeting';
    import Form from '~spa/classes/Form';

    export default {
        components: {
            ModelModal
        },

        data() {
            return {
                modelClass: OpportunityMeeting,
                opportunity: null,
                form: new Form({
                    title: '',
                    text: '',
                    date: '',
                    users_id: [],
                    address: ''
                })
            };
        },

        computed: {
            model()
            {
                return this.$refs.modal?.model || null;
            },
        },

        methods: {
            onOpening(data)
            {
                this.opportunity = data.opportunity;

                this.form.users_id = this.opportunity.getManagers();
                this.form.address = this.opportunity.address;
                this.form.date = this.$moment().format('YYYY-MM-DD');

                if ( this.model ) {
                    this.form.fill(this.model.data());
                    this.form.users_id = this.model.getUsers();
                }
            },

            onReset()
            {
                this.form.stop();
                this.form.reset();
                this.opportunity = null;
            },

            async submit()
            {
                if ( this.form.isLoading() ) {
                    return;
                }   

                this.form.load();
                let data = this.form.data();
                data.users_id = data.users_id.map(user => user.id);
                let action = this.model ? 'update' : 'store';
                let params = this.$refs.modal.model ? {uuid: this.$refs.modal.model.uuid, data: data} : data;

                await window.Worksite.endpoints.opportunityMeeting
                    .setOpportunity(this.opportunity)
                    [action](params);
                    
                this.$refs.modal.close();
            }

        }
    }
</script>